<template>
    <v-col class="checkBox-input">
        <v-checkbox
            hide-details
            class="checkBox pb-2"
            v-model="model"
            :label="label"
            :color="boxColor"
        >
        </v-checkbox>
    </v-col>
</template>

<script type="text/javascript">
  export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        boxColor: {
            type: String,
            default: '',
        },
        value: {
          type: Boolean,
          default: false,
      }
    },
    data() {
      return {
      }
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
  }
</script>


<style  lang="scss">
    
    .checkBox-input {
      .checkBox {
        color: $color-secondary;
        margin-top: 0px !important;
      }
      .v-label.theme--light {
        color: $grey-login-rappel-light !important;
      }
    }

</style>